
import React from 'react'
import '../../_css/Class.css'

// FeatureCard Component
const FeatureCard = ({ title = '', desc = '', subText = '', color = '#F3F4F6' }) => {
    return (
        <div className='class-card' style={{backgroundColor:color}}>
            <div className='class-card-top'>
                <img src = '/menu-icon.svg' width='18px' height='18px' />
                <div>{title}</div>
            </div>
            <div className='class-card-btm'>
                <div>{desc}</div>
                <div className='class-card-btm-t'>{subText}</div>
            </div>
          
        </div>
    );
};

export default FeatureCard